import React from 'react'

import styles from './index.module.css'

type Option = {
  label: string
  value: string | number
}

type Props = {
  options: Option[]
  value: string | number | null
  onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
  placeholder?: string
  className?: string
}

export const Select: React.FC<Props> = ({ options, value, onChange, placeholder, className }) => (
  <select className={`${styles.select} ${className || ''}`} value={value ?? ''} onChange={onChange}>
    {placeholder && <option value="">{placeholder}</option>}
    {options.map((opt) => (
      <option key={opt.value} value={opt.value}>
        {opt.label}
      </option>
    ))}
  </select>
)
